module.exports = __webpack_public_path__ + "static/slider-7a1c58a173cfb9996cfb8296c4ceca1f.png";